import * as IoC from 'typescript-ioc';
import { IJobDescriptionDTO, IJobsDAO, JobDetailsTypes } from '../jobs.dao';
import { IApiClient } from '../../infrastructure/api-client';

class JobsDAO extends IJobsDAO {
    private readonly rootJobsUrl = 'user/long-running-jobs';

    constructor(@IoC.Inject private readonly apiClient: IApiClient) {
        super();
    }

    public async getAllJobsTriggeredByCurrentUser(): Promise<IJobDescriptionDTO<JobDetailsTypes>[]> {
        const requestResult = await this.apiClient.get<IJobDescriptionDTO<JobDetailsTypes>[]>(this.rootJobsUrl);
        return requestResult.parsedResponse;
    }

    public async markJobAsReviewed(jobId: number): Promise<void> {
        const reviewJobUrl = `${this.rootJobsUrl}/{jobId}/reviewed`;
        await this.apiClient.post(reviewJobUrl, {jobId: jobId});
    }
}

export { JobsDAO };
